import React, { Component } from "react";
import Routes from "./routes";
import { ToastContainer } from "react-toastify";
import { X } from "react-feather";
import BigNumber from "bignumber.js/bignumber";

import WalletConnect from "./governor-common/components/walletconnect/WalletConnect";
import { GDAOAddress, POEAddress } from "./utilities/constants/constants";
import ERC20 from "./utilities/constants/ERC20.json";

const Close = ({ closeToast }) => <X size={20} onClick={closeToast} />;
BigNumber.config({ DECIMAL_PLACES: 4 });

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = { GDAOBalance: 0, POEBalance: 0, EnrollmentStatus: 'Unknown' };
    this.walletconnect = null;
    this.web3 = null;
    this.gdaoContract = null;
    this.poeContract = null;
  }

  async componentDidMount() {
    if (!(process.env?.REACT_APP_MOCKED === "true"))
      this.onInitiateWeb3();
  }
  
  onInitiateWeb3 = async () => {
    console.log(`Init WalletConnect: ${process.env?.REACT_APP_CHAIN_ID} ${process.env?.REACT_APP_NETWORK_ID} ${process.env?.REACT_APP_NETWORK_NAME} ${process.env?.REACT_APP_MODAL_NETWORK}`);
    this.walletconnect = await new WalletConnect(
      this.onConnect,
      this.onResetConnect,
      Number(process.env?.REACT_APP_CHAIN_ID),
      Number(process.env?.REACT_APP_NETWORK_ID),
      process.env?.REACT_APP_NETWORK_NAME,
      process.env?.REACT_APP_MODAL_NETWORK      
    );
    await this.walletconnect.connectWeb3();
    this.web3 = this.walletconnect.getWeb3();
  
    let self = this;
    this.getGDAOBalance();
    this.getPOEBalance();
    if (this.statsInterval) {
      clearInterval(this.statsInterval);
    }
    this.statsInterval = setInterval(function () {
      self.getGDAOBalance();
      self.getPOEBalance();
    }, 5000);
    return this.walletconnect;
  }

  onConnect = async (web3) => {
    this.gdaoContract = await new web3.eth.Contract(ERC20.abi, GDAOAddress);
    this.poeContract = await new web3.eth.Contract(ERC20.abi, POEAddress);
    
    window.gdaoContract = this.gdaoContract;
    
    await this.getGDAOBalance();
    await this.getPOEBalance();
    await this.getEnrollmentStatus();
    this.setState({});
  };

  onResetConnect = () => {
    this.setState({});
  };

  getContract = (web3, address) => {
    return new web3.eth.Contract(ERC20.abi, address);
  };

  getGDAOBalance = async () => {
    if (
      this.web3 != null &&
      this.walletconnect?.account != null &&
      this.web3?.utils.isAddress(this.walletconnect?.account) &&
      this.gdaoContract !== null &&
      this.gdaoContract.methods !== null
    ) {
      let balance =
        (await this.gdaoContract.methods
          .balanceOf(this.walletconnect?.account)
          .call()) /
        10 ** 18;
      this.setState({ GDAOBalance: balance });
    }
  };

  getPOEBalance = async () => {
    if (
      this.web3 != null &&
      this.walletconnect?.account != null &&
      this.web3?.utils.isAddress(this.walletconnect?.account) &&
      this.poeContract !== null &&
      this.poeContract.methods !== null
    ) {
      let balance =
        await this.poeContract.methods
          .balanceOf(this.walletconnect?.account)
          .call();
      this.setState({ POEBalance: balance });
    }
  };

  getEnrollmentStatus = async () => {
    const ethAddress = this.walletconnect?.account;
    
    if (!ethAddress)
      return;
    
    let statusUrl = '/govdao/enroll/status?ethereumAddress=' + ethAddress;
    const response = await fetch(statusUrl);
    if (response.ok) {
      const result = await response.json();
      if (result.responseCode === 'SUCC') {
        this.state.EnrollmentStatus = result.enrollmentStatus;
        console.log(result.enrollmentStatus);
      }    
    };
  };

  enableWallet = () => {
    var self = this;
    self.onInitiateWeb3();
  }

  render() {
    return (
      <>
        <ToastContainer
          position={"bottom-right"}
          autoClose={3000}
          closeButton={<Close />}
          pauseOnFocusLoss={false}
          draggable={true}
          draggablePercent={25}
        />
        <Routes
          w3={this.web3}
          walletconnect={this.walletconnect}
          onInitiateWeb3={this.onInitiateWeb3}
          GDAOBalance={this.state.GDAOBalance}
          POEBalance={this.state.POEBalance}
          EnrollmentStatus={this.state.EnrollmentStatus}
          enableWallet={this.enableWallet}
        />
      </>
    );
  }
}
